var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 14.8759H14M9.64048 2.41938L3.70597 7.03512C3.30927 7.34366 3.11092 7.49793 2.96802 7.69113C2.84144 7.86227 2.74715 8.05507 2.68977 8.26005C2.625 8.49146 2.625 8.74274 2.625 9.24531V15.5759C2.625 16.556 2.625 17.046 2.81574 17.4204C2.98352 17.7496 3.25123 18.0174 3.58052 18.1851C3.95486 18.3759 4.44491 18.3759 5.425 18.3759H15.575C16.5551 18.3759 17.0451 18.3759 17.4195 18.1851C17.7488 18.0174 18.0165 17.7496 18.1843 17.4204C18.375 17.046 18.375 16.556 18.375 15.5759V9.24531C18.375 8.74274 18.375 8.49146 18.3102 8.26005C18.2528 8.05507 18.1586 7.86227 18.032 7.69113C17.8891 7.49793 17.6907 7.34366 17.294 7.03512L11.3595 2.41938C11.0521 2.18029 10.8984 2.06074 10.7287 2.01479C10.5789 1.97424 10.4211 1.97424 10.2713 2.01479C10.1016 2.06074 9.94789 2.18029 9.64048 2.41938Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardInactive);
export default __webpack_public_path__ + "static/media/dashboard-inactive.834fc94edc17f08da51bdbbe3845c9a7.svg";
export { ForwardRef as ReactComponent };